/**
 * 入力UIコントロールタイプ。
 */
export const INPUT_TYPE = {
  TEXT: 'text',
  NUMBER: 'number',
  TIME: 'time',
  DATE: 'date',
  RADIO: 'radio',
  SELECT: 'select',
  TEXTAREA: 'textarea',
  PASSWORD: 'password',
  CHECK: 'check',
  SEARCH: 'search',
};

// 型定義。入力値制限。
export type INPUT_TYPE = typeof INPUT_TYPE[keyof typeof INPUT_TYPE];
